import * as React from 'react';
import PropTypes from 'prop-types';

const DebugToolsContext = React.createContext({
  isDebugToolsOpen: false,
  toggleDebugTools: () => {},
  closeDebugTools: () => {},
});

const DebugToolsProvider = ({ children }) => {
  const [isDebugToolsOpen, setIsDebugToolsOpen] = React.useState(false);

  const toggleDebugTools = React.useCallback(() => {
    setIsDebugToolsOpen((currentValue) => !currentValue);
  }, []);

  const closeDebugTools = React.useCallback(() => {
    setIsDebugToolsOpen(false);
  }, []);

  const value = React.useMemo(
    () => ({
      isDebugToolsOpen,
      toggleDebugTools,
      closeDebugTools,
    }),
    [closeDebugTools, isDebugToolsOpen, toggleDebugTools]
  );

  return (
    <DebugToolsContext.Provider value={value}>
      {children}
    </DebugToolsContext.Provider>
  );
};

const useDebugTools = () => {
  const context = React.useContext(DebugToolsContext);

  if (context === undefined) {
    throw new Error('useDebugTools must be used within a DebugToolsProvider');
  }

  return context;
};

DebugToolsProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export { DebugToolsProvider, useDebugTools };
